define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');

    var TableViewController = require('web-agent-framework/TableViewController');
    /**
     * TODO better class API documentation
     * - setEnabled
     * - modelChanged
     * - expandItems
     * - collapseItems
     * - onItemClicked
     * - onFocusedViewClicked
     * - setSelectedIndex
     */

    var BaseDropdownViewController = ViewController.extend({
        ControllerName: "BaseDropdownViewController",

        LPViewMap: {
            itemsContainer: ".lpview_items_container",
            focusElement: ".lpview_focus_element",
            dropdownAnchor: ".lpview_dropdown_anchor"
        },

        LPClassesMap: {
            operative: "operative",
            disabled: "disabled",
            top: "position_top"
        },

        DROPDOWN_POSITIONS: {
            TOP: "top",
            BOTTOM: "bottom"
        },

        initialize: function () {
            this.selectedIndex = this.configuration.selectedIndex;
            this.enabled = typeof this.configuration.enabled !== "undefined" ? this.configuration.enabled : true;
            this.items = this.configuration.items;
            this.textProperty = this.configuration.textProperty;
            this.scrollableContainer = this.configuration.scrollableContainer;  //when given - if the dropdown placed in a scrollable container
                                                                                //it will select the dropdown direction according to the scroll state
            this.itemsDisplayed = false;
            this.titleText = this.configuration.titleText || "{{selectValueBelow}}";
            this.defaultIndex = this.selectedIndex;

            this.initializeView();

            this.filterView = this.configuration.filterViewClass ? this.getFirstElement(this.configuration.filterViewClass) : null;
            this.focusedView = this.getFirstElement(this.configuration.focusedViewClass || this.LPViewMap.focusElement);
            this.itemsContainer = this.getFirstElement(this.LPViewMap.itemsContainer);
            this.dropdownAnchor = this.getFirstElement(this.LPViewMap.dropdownAnchor);

            this.dropdownView = new TableViewController({
                ControllerName: "TableViewController(BaseDropdownViewController)",
                context: this,
                rowTemplateFile: this.configuration.rowTemplateFile,
                noDataTemplate: this.configuration.noDataTemplate,
                modelData: this.items,
                modelPath: this.configuration.itemsModelPath,
                dataRenderer: this.configuration.dataRenderer || this.dataRenderer,
                dataBinder: this.dataBinder,
                lineClicked: this.onItemClicked,
                supportKeysNavigation: true,
                focusedView: this.focusedView,
                filterView: this.filterView,
                rowsSortFunction: this.configuration.rowsSortFunction
            });
            this.addViewController({viewController: this.dropdownView, target: this.LPViewMap.itemsContainer});
        },

        events : function () {
            this.bindViewEvent({view: this.focusedView, DOMEvent: "click", callback: this.onFocusedViewClicked});
            this.bindViewEvent({view: this.focusedView, DOMEvent: "blur", callback: this.collapseItems, ignoreChildBlur: true});
        },

        render : function () {
            this.setEnabled(this.enabled);
        }
    });

    BaseDropdownViewController.prototype.getConfiguration = function () {
        var configuration = {
            baseTemplateFile: "LP_base_dropdown.html",
            noDataTemplate: "LP_base_dropdown_no_items.html",
            rowTemplateFile: "LP_form_dropdown_row.html",
            textProperty: "text"
        };
        return configuration;
    };

    BaseDropdownViewController.prototype.initializeView = function () {
        var dropdownTemplate = require('web-agent-templates/' + this.configuration.templateFile);
        var baseDropdownTemplate = require('web-agent-templates/' + this.configuration.baseTemplateFile);
        // var dropdownTemplate = lpUtils.loadResource(this.configuration.templateFile);
        // var baseDropdownTemplate = lpUtils.loadResource(this.configuration.baseTemplateFile);
        dropdownTemplate = this.injectTextDefaults(dropdownTemplate, { baseDropdownPlaceholder : baseDropdownTemplate, titlePlaceholder: this.titleText, noDataText : this.noDataText });
        this.createView({template:dropdownTemplate, wrapWithDiv : false});
    };

    BaseDropdownViewController.prototype.expandItems = function() {
        if (this.enabled && !this.itemsDisplayed) {
            this.addClass(this.itemsContainer, this.LPClassesMap.operative);
            this.addClass(this.dropdownAnchor, this.LPClassesMap.operative);
            if(this.dropdownPosition === this.DROPDOWN_POSITIONS.TOP) {
                this.addClass(this.itemsContainer, this.LPClassesMap.top);
            }
            this.itemsDisplayed = true;
            this.setDropdownWidth();
        }
    };

    BaseDropdownViewController.prototype.collapseItems = function (e) {
        if (this.enabled && this.itemsDisplayed) {
            this.removeClass(this.itemsContainer, this.LPClassesMap.operative);
            this.removeClass(this.dropdownAnchor, this.LPClassesMap.operative);
            this.removeClass(this.itemsContainer, this.LPClassesMap.top);
            this.itemsDisplayed = false;
            this.applyLostFocusCallback(e);
        }
    };

    BaseDropdownViewController.prototype.setEnabled = function (enabled) {
        if (this.enabled === enabled) {
            return;
        }
        this.enabled = enabled;
        if (this.enabled) {
            this.removeClass(this.itemsContainer, this.LPClassesMap.disabled);
        } else {
            if (this.itemsDisplayed) {
                this.collapseItems();
            }
            this.addClass(this.itemsContainer, this.LPClassesMap.disabled);
        }
    };

    BaseDropdownViewController.prototype.onItemClicked = function (data) {
        if (!this.enabled) {
            return;
        }
        this.selectedIndex = data.rowIndex;
    };

    BaseDropdownViewController.prototype.onFocusedViewClicked = function (e) {

        if (!this.itemsDisplayed && this.scrollableContainer) {

            if (_.isString(this.scrollableContainer)) {
                this.scrollableContainer = this.getParentElementBySingleSelector(this.view, this.scrollableContainer);
                if (!this.scrollableContainer) {
                    return;
                }
            }

            //determine the dropdown direction according to the scroll status

            var containerRect = this.scrollableContainer.getBoundingClientRect();
            var thisRect = this.view.getBoundingClientRect();

            var maxHeight = 155;    //as declared in 'operative' class
            var estimatedDropdownHeight = Math.min(this.items.length * 35, maxHeight);

            if ((containerRect.bottom - thisRect.bottom) >= estimatedDropdownHeight || estimatedDropdownHeight > thisRect.top - containerRect.top) {
                this.setDropdownPosition(this.DROPDOWN_POSITIONS.BOTTOM);
            } else {
                this.setDropdownPosition(this.DROPDOWN_POSITIONS.TOP);
            }
        }
    };

    BaseDropdownViewController.prototype.modelChanged = function () {
        this.dropdownView.modelChanged();
    };

    BaseDropdownViewController.prototype.getItems = function () {
        return this.items;
    };

    BaseDropdownViewController.prototype.updateModelData = function (data) {
        this.items = data;
        this.dropdownView.updateModelData(this.items);
    };

    BaseDropdownViewController.prototype.setSelectedIndex = function (index) {
        this.selectedIndex = index;
    };

    BaseDropdownViewController.prototype.dataRenderer = {
        numberOfSections: function () {
            return 1;
        },
        numberOfRowsInSection: function (data) {
            return data.length;
        },
        dataForSection: function () {
            return;
        },
        dataForRowInSection: function (data, rowIndex) {
            var rowData = data[rowIndex];
            var value = {text: "", rowData: rowData, id: rowIndex};
            value.text = typeof rowData === 'string' ? rowData : rowData[this.textProperty];
            value.title = rowData.title || "";
            value.disabled = rowData.disabled ? "disabled" : "";
            return value;
        },
        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }
            var split = filterText.toLowerCase().split(' ');
            for (var index = 0; index < split.length; index++) {
                var partialTitle = data[this.textProperty].toLowerCase().indexOf(split[index]) >= 0;
                if (!partialTitle) {
                    return true;
                }
            }
            return false;
        },
        getPropertiesForHighlight: function () {
            return {text: true};
        }
    };

    BaseDropdownViewController.prototype.dataBinder = {
        operationCanceled: function () {
            this.collapseItems();
        }
    };

    BaseDropdownViewController.prototype.setDropdownWidth = function () {
        var anchorWidth = this.dropdownAnchor.offsetWidth - 2; // removing the 2px added from borders.
        this.setStyle(this.itemsContainer, {width: anchorWidth + "px"});
    };

    BaseDropdownViewController.prototype.applyLostFocusCallback = function (e) {
        if (this.lostFocusCallback) {
            this.lostFocusCallback.call(this.context, e);
        }
    };

    /**
     * Set the dropdown position - can be either top or bottom
     * @param {String} position "top" od "bottom"
     */
    BaseDropdownViewController.prototype.setDropdownPosition = function (position) {
        this.dropdownPosition = position;
    };

    return BaseDropdownViewController;

});
